import { Link } from "react-router-dom";
import { Phone, ClipboardList } from "lucide-react";
import { COMPANY } from "@/lib/site";

export const MobileStickyCTA = () => {
  return (
    <div
      data-testid="mobile-sticky-cta"
      className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-[#0E3A1F]/95 backdrop-blur-md border-t border-white/10 px-3 py-2.5 flex items-center gap-2 shadow-[0_-10px_30px_-15px_rgba(0,0,0,0.5)]"
    >
      <a
        href={COMPANY.telHref}
        data-testid="mobile-sticky-call"
        className="flex-1 flex items-center justify-center gap-2 bg-white text-[#0E3A1F] rounded-full py-3 font-bold text-sm"
      >
        <Phone className="h-4 w-4" /> Call Now
      </a>
      <Link
        to="/quote"
        data-testid="mobile-sticky-quote"
        className="flex-1 flex items-center justify-center gap-2 bg-[#5BB23B] text-white rounded-full py-3 font-bold text-sm"
      >
        <ClipboardList className="h-4 w-4" /> Free Quote
      </Link>
    </div>
  );
};

export default MobileStickyCTA;
